import type { Action } from '../../store/state/state-manager';

/* action type */
export const GET_DESCENDANTS = 'GET_DESCENDANTS';

/* action creator */
export const getDescendantsAction = (actionPayload: Action['payload']) => {
  return {
    type: GET_DESCENDANTS,
    payload: actionPayload
  };
};
